import TraitView from './TraitView';
const cid = '';
const HTML = `
<div class="toggle-button ${cid}">
    <div class="flex-center">
        <span></span>
        <section class="model-2">
            <div class="checkbox">
                <input class="js-bind-toggle-boolean hidden" data-props="required" type="checkbox" data-rv-checked="model.required" tabindex="0">
                <label></label>
            </div>
        </section>
    </div>
</div>
`;

export default TraitView.extend({
  createInput({ trait }) {
    const el = document.createElement('div');
    const { cid } = this;
    const initValue = this.model.get('default');

    el.innerHTML = HTML;
    const Traits = this;
    const $toggleEl = el.querySelector('input');

    this.value = initValue;
    $toggleEl.addEventListener('change', ev => {
      var context = Traits;
      var visibilityJSON = context.model.get('visibility');
      Traits.model.collection.models.forEach(function(trait) {
        trait.view.show();
      });

      var hideTrait = Traits.model.collection.models.filter(function(trait) {
        return trait.attributes.name == 'bind_from';
      });

      hideTrait.forEach(function() {
        trait.view.hide();
      });
    });
    return el;
  },
  templateInput({ trait }) {
    return '<div ...';
  },
  initTrait() {
    this.model.view.triggerVisibility();
  },
  triggerVisibility() {
    let visibilityJSON = this.model.get('options');
  }
});
